export default __webpack_public_path__ + "static/ISO9001-0741f18df4dafa974a7b00924739c00d.svg";